import { Tooltip, Typography } from '@mui/material';
import { DateTime } from '@utils';
import CreateAndEditDetails from '@AccessFlows/components/CreateAndEditDetails';
import { CommonAccessFlowAppModel } from '@AccessFlows/common/types';

interface AccessFlowCreationDetailsProps {
  accessFlow: CommonAccessFlowAppModel;
}

export default function AccessFlowCreationDetails({ accessFlow }: AccessFlowCreationDetailsProps) {
  return (
    <Tooltip
      title={
        <CreateAndEditDetails
          editedDate={accessFlow.updated_date}
          createdDate={accessFlow.created_date}
          editedBy={accessFlow.update_user}
          createdBy={accessFlow.creation_user}
          withPaper={false}
          variant="small"
        />
      }
      arrow
    >
      <Typography variant="helperText" color="text.muted">
        Created: <strong>{DateTime.fromUnix(Number(accessFlow.created_date)).readable}</strong>
      </Typography>
    </Tooltip>
  );
}
